import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const FindSimilarAdModalPage = withCompass(
  () => import("../../pages/FindSimilarAdModalPage")
);
const NextGenSearchPage = withCompass(
  () => import("../../pages/NextGenSearchPage")
);

export function ShilpaSubrahmanyamRoutes() {
  return (
    <Switch>
      <Route
        path="/ss/search/find-similar-ad-modal"
        component={FindSimilarAdModalPage}
      />
      <Route path="/ss/next-gen-search" component={NextGenSearchPage} />
    </Switch>
  );
}

export const slug = "ss";
